// v1.4.0 · Banderas en SVG (los emojis de bandera no se ven en Windows: muestran solo las letras)
import React from 'react';

const SUN = (cx, cy, r, fill) => <circle cx={cx} cy={cy} r={r} fill={fill} />;

const FLAGS = {
  ec: (
    <>
      <rect width="30" height="10" fill="#FFDD00" />
      <rect y="10" width="30" height="5" fill="#034EA2" />
      <rect y="15" width="30" height="5" fill="#ED1C24" />
      <ellipse cx="15" cy="10" rx="2.6" ry="3.2" fill="#6B8E23" stroke="#7A5C1E" strokeWidth=".6" />
    </>
  ),
  pe: (
    <>
      <rect width="30" height="20" fill="#fff" />
      <rect width="10" height="20" fill="#D91023" />
      <rect x="20" width="10" height="20" fill="#D91023" />
    </>
  ),
  mx: (
    <>
      <rect width="30" height="20" fill="#fff" />
      <rect width="10" height="20" fill="#006847" />
      <rect x="20" width="10" height="20" fill="#CE1126" />
      {SUN(15, 10, 2.6, '#8C6239')}
    </>
  ),
  co: (
    <>
      <rect width="30" height="10" fill="#FCD116" />
      <rect y="10" width="30" height="5" fill="#003893" />
      <rect y="15" width="30" height="5" fill="#CE1126" />
    </>
  ),
  us: (
    <>
      <rect width="30" height="20" fill="#fff" />
      {Array.from({ length: 7 }, (_, i) => (
        <rect key={i} y={i * 2 * (20 / 13)} width="30" height={20 / 13} fill="#B22234" />
      ))}
      <rect width="12" height={(20 / 13) * 7} fill="#3C3B6E" />
    </>
  ),
  ar: (
    <>
      <rect width="30" height="20" fill="#74ACDF" />
      <rect y="6.67" width="30" height="6.66" fill="#fff" />
      {SUN(15, 10, 2, '#F6B40E')}
    </>
  ),
};

export default function Flag({ code, title, className = '' }) {
  const f = FLAGS[code];
  if (!f) return null;
  return (
    <svg viewBox="0 0 30 20" width="24" height="16" role="img" aria-label={title}
         className={`shrink-0 overflow-hidden rounded-[2px] ring-1 ring-black/10 ${className}`}>
      {f}
    </svg>
  );
}
